import classnames from 'classnames';
import { PureComponent } from 'react';

import styles from './messageWidgetOption.module.scss';

type PropsT = {
  /** Extra classnames */
  className?: string;
  /** Option text */
  text: string;
};

export class MessageWidgetOption extends PureComponent<PropsT> {
  render() {
    const { className, text, ...otherProps } = this.props;

    const rootClass = classnames(
      {
        [styles.root]: true,
      },
      className,
    );

    return (
      <div {...otherProps} className={rootClass}>
        {text}
      </div>
    );
  }
}
